<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://itgroup.systems" target="_blank">Itgroup Systems</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }} &nbsp;</span>
      <span class="ml-1">Versión v{{ version }}</span>
      <span class="ml-1">Última actualización {{ last_update }}</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {
      version: process.env.MIX_APP_VERSION,
      last_update: process.env.MIX_APP_LAST_UPDATE
    }
  }
};
</script>
